module.exports = __webpack_public_path__ + "static/media/ALPACA-BUSD.c0de27c5.svg";